// extracted by mini-css-extract-plugin
export var clear = "Layout-module--clear--4da69";
export var root = "Layout-module--root--196fd";